const LIST_INFO_SKUS_KEY = '_itemListInfo';

export type ListInfoForSkuType = {
  sku: string;
  listName?: string;
  listSlot?: string;
  listServiceConfig?: string;
};

export const getListInfoForSkus = () => {
  const listInfoForSkusString = window.sessionStorage.getItem(LIST_INFO_SKUS_KEY);
  if (!listInfoForSkusString) return null;
  return JSON.parse(listInfoForSkusString) as Array<ListInfoForSkuType>;
};

export const getListInfoForSku = (sku: string) => {
  const listInfoForSkusString = window.sessionStorage.getItem(LIST_INFO_SKUS_KEY);
  if (!listInfoForSkusString) return null;
  const listInfoForSkus = JSON.parse(listInfoForSkusString) as Array<ListInfoForSkuType>;
  if (sku) return listInfoForSkus?.find(item => item.sku === sku);
  return null;
};

export const addListInfoForSku = ({ sku, listName, listSlot, listServiceConfig }: ListInfoForSkuType) => {
  const listInfoForSkus = getListInfoForSkus() || [];
  listInfoForSkus.push({ sku, listName, listSlot, listServiceConfig });
  window.sessionStorage.setItem(LIST_INFO_SKUS_KEY, JSON.stringify(listInfoForSkus));
};

export const removeListInfoForSku = (sku: string) => {
  const listInfoForSkus = getListInfoForSkus();
  if (!listInfoForSkus) return null;
  window.sessionStorage.setItem(LIST_INFO_SKUS_KEY, JSON.stringify(listInfoForSkus.filter(item => item.sku !== sku)));
};
